import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    display: 'block',
    width: '100%',
    overflowX: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    '-ms-overflow-style': '-ms-autohiding-scrollbar'
  },
  enabledActions: {
    paddingBottom: theme.spacing.unit * 6
  }
});

const Tresponsive = ({ children, enabledActions, ...rest}) => {

  const { classes }  = rest;

  return (
    <div className={ classNames(classes.root, enabledActions ? classes.enabledActions : null ) }>
      { children }
    </div>
  );

}

Tresponsive.propTypes = {
  children: PropTypes.node
};

export default withStyles(styles)(Tresponsive);
